import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';

export default function ServiceCard({ service }) {
    return (
        <>
            <div className='single-service-card-wrapper'>
                <div className='service-card-header'>
                    <div className='service-card-header-image'>
                        <img src={require(`../../assests/${service.service_image}`)} alt="service-image" className='img-fluid' />
                        <div className='img-vector-bottom-left'></div>
                        <div className='img-vector-white-bottom-left'></div>
                        <div className='img-vector-top-right'></div>
                    </div>
                    <div className='service-header-icon-wrapper'>
                        <div className='service-icon-placeholder'>
                            <img src={require(`../../assests/${service.service_icon}`)} alt="icon" />
                        </div>
                    </div>
                </div>
                <div className='service-card-body text-center'>
                    <h5 className='s-title'><Link to={"#"}>{service.title}</Link></h5>
                    <p className='themeGrayPara in-fs lh-28'>{service.desc}</p>
                </div>
                <div className='service-card-footer text-center'>
                    <a href={`${service.link}`}><FontAwesomeIcon icon={faLongArrowAltRight} />Read More<FontAwesomeIcon icon={faLongArrowAltRight} /></a>
                </div>
            </div>
        </>

    )
}
